import { useContext } from 'react'

import TripItemSummaryCard from '../SummaryCards/TripItem/TripItemSummaryCard'

import type { TripItem } from 'tripPlanner/types/tripItem'
import { TripMapContext } from 'tripPlanner/contexts/TripMapContext'
import SavedLEExperienceSummaryCard from '../SummaryCards/LEOffer/SavedLEExperienceSummaryCard'
import SavedLEHotelSummaryCard from '../SummaryCards/LEOffer/SavedLEHotelSummaryCard'
import { LE_CONTRACTED_HOTEL_TYPES } from 'constants/offer'

interface Props {
  selectedItem: TripItem | undefined
}

function TripItemCardSingle({
  selectedItem,
}: Props) {
  const { onDeselectMapItem } = useContext(TripMapContext)

  if (!selectedItem) {
    return null
  } else if (selectedItem.type === 'EXPERIENCE' && selectedItem.code) {
    return (
      <SavedLEExperienceSummaryCard
        item={selectedItem}
        experienceId={selectedItem.code}
        onClose={onDeselectMapItem}
      />
    )
  } else if (selectedItem.type === 'ACCOMMODATION' && selectedItem.code && LE_CONTRACTED_HOTEL_TYPES.includes(selectedItem.savedItemData?.offerType!)) {
    return (
      <SavedLEHotelSummaryCard
        item={selectedItem}
        offerId={selectedItem.code}
        onClose={onDeselectMapItem}
      />
    )
  } else {
    return (
      <TripItemSummaryCard
        item={selectedItem}
        showCloseButton
        onClose={onDeselectMapItem}
      />
    )
  }
}

export default TripItemCardSingle
